import { render, staticRenderFns } from "./HeaderMenuModular.vue?vue&type=template&id=12369e27&scoped=true&"
import script from "./HeaderMenuModular.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuModular.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuModular.vue?vue&type=style&index=0&id=12369e27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12369e27",
  null
  
)

export default component.exports